import BaseFeature from '../../foundation/base/base';

export default class HeroBanner extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.el = element;
		// This component has a background that should be set to a specific height.
		// To do this we need to calculate the height of the component itself and space above.

		this.targetHeight = 400; // Target height of background
		this.bottomDistance = 20; // Component uses this spacing bellow that we cannot acquire
		this.resizeTimeout = null; // Used by the resize function to throttle resize event
		this.setBackgroundHeight();
		this.initEvents();
	}

	initEvents() {
		window.addEventListener('resize', () => {
			this.resizeThrottler();
		});
	}

	resizeThrottler() {
		// Ignore resize events as long as an actualResizeHandler execution is in the queue
		if (!this.resizeTimeout) {
			this.resizeTimeout = setTimeout(() => {
				this.resizeTimeout = null;
				this.actualResizeHandler();
				// The actualResizeHandler will execute at a rate of 15fps
			}, 66);
		}
	}

	actualResizeHandler() {
		this.setBackgroundHeight();
	}

	setBackgroundHeight() {
		// Get computed distance to top of page
		const offsetTop = this.getOffsetDistance();
		// Set background height based on space available.
		// This is to make sure the background content is fully visible
		if (this.dom.background) {
			this.dom.background.style.height = (offsetTop + this.el.offsetHeight + this.bottomDistance) + 'px';
			this.dom.overlay.style.height = (offsetTop + this.el.offsetHeight + this.bottomDistance) + 'px';
		}
	}

	getOffsetDistance() {
		let element = this.el;
		let location = 0;
		if (element.offsetParent) {
			do {
				location += element.offsetTop;
				if (element.offsetParent.classList.contains('t-page')) {
					element = null; // We need to break on t-page to not conflict with xp-editor
				} else element = element.offsetParent;
			} while (element);
		}
		return location >= 0 ? location : 0;
	}
}
